const THREE = require('three')
import scene from './scene'
import camera from './camera'
import {TweenMax, Cubic} from 'gsap'
import {config as gameConfig} from './config'
import * as colors from './colors'

// *****************************************************************
//
// HEMI LIGHT
//
// *****************************************************************
export let hemiLight = new THREE.HemisphereLight(0xffffff, 0xffffff, 0.5)
hemiLight.color.setHSL(0.6, 1, 0.6)
hemiLight.groundColor.setHSL(1, 1, 0.75)
hemiLight.position.set(0, 5000, 500)
hemiLight.position.multiplyScalar(gameConfig.worldScale)
scene.add(hemiLight)


// SHADOW
// hemiLight.castShadow = true
// hemiLight.shadow.mapSize.width = 2048
// hemiLight.shadow.mapSize.height = 2048
// hemiLight.shadow.camera.near = 0.5
// hemiLight.shadow.camera.far = 50

// // HELPER
// var hemiLightHelper = new THREE.HemisphereLightHelper( hemiLight, 5 )
// scene.add( hemiLightHelper )



// *****************************************************************
//
// DIR LIGHT
//
// *****************************************************************
export let dirLight = new THREE.DirectionalLight(0xFFFFFF, 0.8)
dirLight.position.set( 0, 240, -1000 )
scene.add(dirLight)

// TARGET
dirLight.target = new THREE.Object3D()
scene.add(dirLight.target)

// SHADOW
dirLight.castShadow = true
dirLight.shadow.mapSize.width = 2048
dirLight.shadow.mapSize.height = 2048
let size = 50
dirLight.shadow.camera.left = -size
dirLight.shadow.camera.bottom = -size
dirLight.shadow.camera.right = size
dirLight.shadow.camera.top = size
dirLight.shadow.camera.near = 1
dirLight.shadow.camera.far = 100000

// HELPER
// var pointLightHelper = new THREE.PointLightHelper( dirLight, 5 )
// scene.add( pointLightHelper )
// var helper = new THREE.CameraHelper( dirLight.shadow.camera )
// scene.add(helper)


// *****************************************************************
//
// SPOT LIGHT
//
// *****************************************************************
// export let spotLight = new THREE.SpotLight(
//   // colors.blue.clone(),
//   0xFFFFFF,
//   0.8, // INTENSITY
//   240, // DISTANCE
//   15 * THREE.Math.DEG2RAD, // ANGLE
//   0.1, // PENUMBRA
//   1 // DECAY
// )
// spotLight.position.set(15, 15, -20)
// scene.add(spotLight)

// // TARGET
// let spotLightTarget = new THREE.Object3D()
// spotLightTarget.position.set(-60, 50, -50)
// scene.add(spotLightTarget)
// spotLight.target = spotLightTarget

// // SHADOW
// spotLight.castShadow = true
// spotLight.shadow.mapSize.width = 1024
// spotLight.shadow.mapSize.height = 1024
// spotLight.shadow.camera.near = 1
// spotLight.shadow.camera.far = 10000

// // HELPER
// var spotLightHelper = new THREE.SpotLightHelper( spotLight )
// scene.add(spotLightHelper)
// var helper = new THREE.CameraHelper( spotLight.shadow.camera )
// scene.add(helper)

// TweenMax.to(spotLightTarget.position, 2, {
//   z: 50,
//   repeat: -1,
//   yoyo: true,
//   ease: Cubic.easeInOut
// })




// *****************************************************************
//
// POINT LIGHT
//
// *****************************************************************
// export let ptLight1 = new THREE.PointLight(0xFFFFFF, 1, 100)
// ptLight1.position.x = -10
// ptLight1.position.y = 20
// ptLight1.position.z = 60
// scene.add(ptLight1)

// // SHADOW
// ptLight1.castShadow = true
// ptLight1.shadow.mapSize.width = 1024
// ptLight1.shadow.mapSize.height = 1024
// ptLight1.shadow.camera.near = 1
// ptLight1.shadow.camera.far = 10000

// // HELPER
// var ptLight1Helper = new THREE.PointLightHelper( ptLight1, 5 )
// scene.add(ptLight1Helper)


// TweenMax.to(ptLight1.position, 2, {
//   z: -60,
//   repeat: -1,
//   yoyo: true,
//   ease: Cubic.easeInOut
// })

// *****************************************************************
//
// POINT LIGHT 2
//
// *****************************************************************
export let ptLight2 = new THREE.PointLight(0x0011FF, 1, 100)
ptLight2.position.y = 50




// *****************************************************************
//
// METHODS
//
// *****************************************************************
export const animColor = function (light, color, time = 1) {
  let toColor = new THREE.Color(color)
  TweenMax.to(light.color, time, {
    r: toColor.r,
    g: toColor.g,
    b: toColor.b,
    ease: Cubic.easeInOut
  })
}


// WEBPACK FOOTER //
// ./src/components/game/lights.js